import React from 'react';

const NotFoundPage = () => <h1>404 NOT FOUND</h1>;

export default NotFoundPage;
